import { Container, Row, Col } from '@ui/wrapper'
import Image from '@ui/image'
import Accordion from '@ui/accordion'

import { BorderCol, SectionWrapper, StyledImage, StyledText } from './style'

const BSWVeranstaltungArea = ({ data, dataMessage, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      {dataMessage && (
        <Container style={{ marginTop: '30px' }}>
          <Accordion
            data={dataMessage?.items}
            defaultActiveKey={dataMessage?.defaultActiveKey}
          />
        </Container>
      )}
      <Container>
        <Row>
          {data?.images?.length > 0 && (
            <BorderCol lg={6} style={{ display: 'flex', alignItems: 'center' }}>
              <StyledImage>
                <Image
                  src={data?.images[0]?.src.localFile || data?.images[0]?.src}
                  alt={data?.images[0]?.src.alternativeText || ''}
                  sizes="(max-width: 1000px) 125vw, 50vw"
                />
              </StyledImage>
            </BorderCol>
          )}
          <Col
            lg={data?.images?.length > 0 ? 6 : 12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            {data?.texts?.map((text, i) => (
              <StyledText
                key={i}
                dangerouslySetInnerHTML={{
                  __html: text.content
                }}
              />
            ))}
          </Col>
        </Row>
      </Container>
    </SectionWrapper>
  )
}

export default BSWVeranstaltungArea
